export default __webpack_public_path__ + "static/media/rotor-adapters.e50fce23.svg";